import { useCallback, useState } from "react"

import { FormDialog } from "components/dialog/form"

import { EvaluationConsideration, usePostEvaluationResult } from "interface/search/evaluation"
import { FormControl, Stack, TextField } from "@mui/material"

type useConsiderationEditFormProps = {
  searchId: number
  kojinCode: string
  fieldId: string,
  storeData: {
    content: string | undefined,
  },
  onSubmit: (row: EvaluationConsideration) => void
}
const useConsiderationEditForm = ({
  searchId,
  kojinCode,
  fieldId,
  storeData,
  onSubmit
}: useConsiderationEditFormProps) => {
  const [content, setContent] = useState<string>(storeData.content ?? '')

  const onPosted = useCallback(
    () => {
      onSubmit({ fieldId, content })
    },
    [onSubmit, fieldId, content]
  )
  const [postState, post] = usePostEvaluationResult(
    searchId,
    kojinCode,
    { onPosted }
  )
  const submit = useCallback(
    () => {
      post({
        fields: [
          { fieldId, value: content.trim() }
        ]
      })
    },
    [post, fieldId, content]
  )
  return {
    content, setContent,
    submit,
    error: postState.error,
    posting: postState.posting
  }
}

const ConsiderationEditForm = ({
  content, setContent
}: ReturnType<typeof useConsiderationEditForm>) => {
  return (
    <Stack direction="column">
      <FormControl size="small" sx={{ flexGrow: 1 }}>
        <TextField
          value={content}
          onChange={(event) => setContent(event.target.value)}
          variant="outlined"
          fullWidth
          multiline
          size="small"
        />
      </FormControl>
    </Stack>
  )
}

type ConsiderationEditDialogProps = {
  searchId: number
  kojinCode: string
  row: EvaluationConsideration
  onSubmit: (row: EvaluationConsideration) => void
  onClose: () => void
}
export const ConsiderationEditDialog = ({
  searchId,
  kojinCode,
  row: {
    fieldId,
    content
  },
  onSubmit,
  onClose
}: ConsiderationEditDialogProps) => {
  const form = useConsiderationEditForm({
    searchId,
    kojinCode,
    fieldId,
    storeData: {      
      content
    },
    onSubmit
  })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="sm"
      title={`${fieldId}編集`}
      isLoading={form.posting}
      error={form.error}
      body={<ConsiderationEditForm {...form}/>}
      submitLabel="保 存"
      onSubmit={(e) => {
        e.preventDefault()
        form.submit()
      }}
      onClose={onClose}
    />
  )
}